import { Component, Input, OnInit } from '@angular/core';
import { MenuService } from '../app.menu.service';
import { ColorScheme, LayoutService, MenuColorScheme, MenuMode,} from '../service/app.layout.service';
import { LocalStoreService } from '../../LocalStoreService/local-store.service';
import { ConfirmationService } from 'primeng/api';
import { AppConfigServie } from './app.config.service';
import { StorageService } from '../../_services/storage.service';
@Component({
    selector: 'app-config',
    templateUrl: './app.config.component.html',
    providers: [ConfirmationService],
})
export class AppConfigComponent implements OnInit {
    @Input() minimal: boolean = false;

    componentThemes: any[]  = [];
    scales: number[]        = [12, 13, 14, 15, 16];
    aviso: boolean          = true;
    loading: boolean        = false;

    constructor(
        public layoutService: LayoutService,
        public menuService: MenuService,
        private ls: LocalStoreService,
        private confirmationService: ConfirmationService,
        private appConfigServie: AppConfigServie,
        private storageService: StorageService,
    ) {}

    get visible(): boolean {
        return this.layoutService.state.configSidebarVisible;
    }
    set visible(_val: boolean) {
        this.loading    = true;
        let input: any  = {};
        input.cor       = this.layoutService.config().theme;
        input.tipo_menu = this.layoutService.config().menuMode;
        input.tema_menu = this.layoutService.config().menuTheme;
        input.escala    = this.layoutService.config().scale;
        input.tema      = this.layoutService.config().colorScheme;
        input.input     = this.layoutService.config().inputStyle;
        input.id_agente = this.ls.getItem('agente');

        this.appConfigServie.atualizarLayout(input).then(
        (response) => {
            this.layoutService.state.configSidebarVisible   = _val;
            this.loading                                    = false;

            let acoes = this.storageService.getUser() || {};
            acoes.preferencias = input;
            this.storageService.saveUser(acoes);
        },
        (error) => {
            this.loading                                    = false;
            this.confirmationService.confirm({
                header: 'Erro ao salvar',
                message: `${error.error.message || error.error.mensagem || error.mensagem}.`,
                accept: () => {
                }
            });
        });
    }

    get scale(): number {
        return this.layoutService.config().scale;
    }
    set scale(_val: number) {
        this.layoutService.config.update((config) => ({
            ...config,
            scale: _val,
        }));
    }

    get menuMode(): MenuMode {
        return this.layoutService.config().menuMode;
    }
    set menuMode(_val: MenuMode) {
        this.layoutService.config.update((config) => ({
            ...config,
            menuMode: _val,
        }));
        if (
            this.layoutService.isSlimPlus() ||
            this.layoutService.isSlim() ||
            this.layoutService.isHorizontal()
        ) {
            this.menuService.reset();
        }
    }

    get colorScheme(): ColorScheme {
        return this.layoutService.config().colorScheme;
    }
    set colorScheme(_val: ColorScheme) {
        this.layoutService.config.update((config) => ({
            ...config,
            colorScheme: _val,
        }));
    }

    get inputStyle(): string {
        return this.layoutService.config().inputStyle;
    }
    set inputStyle(_val: string) {
        this.layoutService.config.update((config) => ({
            ...config,
            inputStyle: _val,
        }));
    }

    get ripple(): boolean {
        return this.layoutService.config().ripple;
    }
    set ripple(_val: boolean) {
        this.layoutService.config.update((config) => ({
            ...config,
            ripple: _val,
        }));
    }

    get menuTheme(): MenuColorScheme {
        return this.layoutService.config().menuTheme;
    }
    set menuTheme(_val: MenuColorScheme) {
        this.layoutService.config.update((config) => ({
            ...config,
            menuTheme: _val,
        }));
    }

    get theme(): string {
        return this.layoutService.config().theme;
    }
    set theme(_val: string) {
        this.layoutService.config.update((config) => ({
            ...config,
            theme: _val,
        }));
    }

    ngOnInit() {
        this.componentThemes = [
            { name: 'indigo', color: '#6366F1' },
            { name: 'blue', color: '#3B82F6' },
            { name: 'purple', color: '#8B5CF6' },
            { name: 'teal', color: '#14B8A6' },
            { name: 'cyan', color: '#06b6d4' },
            { name: 'green', color: '#10b981' },
            { name: 'orange', color: '#f59e0b' },
            { name: 'pink', color: '#d946ef' },
            { name: 'christmas', color: '#c41e3a', icon: '🎄', label: 'Natal' },
            { name: 'carnival', color: '#9c27b0', icon: '🎉', label: 'Carnaval' },
        ];
    }

    permissaoAlterar(){
        return true;
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    changeColorScheme(colorScheme: ColorScheme) {
        this.colorScheme = colorScheme;
    }

    changeTheme(theme: string) {
        this.theme = theme;
    }

    decrementScale() {
        this.scale--;
    }

    incrementScale() {
        this.scale++;
    }
}
